import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
    text: {
        fontSize: 33,
        lineHeight: '1.2em'
    },
    formComponent: {
        width: "100%"
    },
    pullLeft: {
        float: "left"
    },


    inputSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        '& .MuiFormGroup-row': {
            justifyContent: 'center',
        }
    },
}))

export default styles;